function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr && (typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]); if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

/** @module hooks/modal */
import hooks from "../util/hooks";
import wp from "wp";
import $ from "jquery";
import { restoreMediaViewSelection } from "../others/mediaViews";
/**
 * Get the backbone controller of the modal.
 *
 * @param {object} element The DOM element
 * @returns {Controller} The backbone controller
 */

export function getModalControllerOf(element) {
  try {
    return $(element).parents(".rml-modal").data("backboneView").controller;
  } catch (e) {
    return null;
  }
}
/**
 * The sortable state gets refreshed so check if we have to destroy the
 * draggable instance.
 *
 * @returns {boolean}
 */

export function isAttachmentsBrowserSortable(element) {
  try {
    var attachments = element.attachmentsBrowser.attachments;
    return !attachments.$el.sortable("option", "disabled");
  } catch (e) {
    return false;
  }
}
/**
 * @returns {boolean}
 */

export function isAttachmentsGalleryEdit(attachments) {
  try {
    return attachments.options.model.get("toolbar") === "gallery-edit";
  } catch (e) {
    return false;
  }
}

if (process.env.PLUGIN_CTX === "pro") {
  /* onlypro:start */
  var appendMediaModalClass = function appendMediaModalClass() {
    $(".rml-modal-container .aiot-pad > div:nth-child(2)").each(function () {
      var parent = $(this).parents(".rml-media-modal"),
          menu = parent.find(".media-frame-menu .media-menu"),
          menuHeight = menu.get(0).offsetHeight,
          oppositeHeight = menu.children(":not(.rml-modal-container)").get().map(function (c) {
        return c.offsetHeight;
      }).reduce(function (a, b) {
        return a + b;
      }, 0);

      if (menuHeight - oppositeHeight > 300) {
        parent.removeClass("rml-mobile-modal");
      } else {
        parent.addClass("rml-mobile-modal");
      }
    });
  };
  /**
   * When there is a new attachments browser in modal view then
   * prepare the media view for the AppTree container.
   */


  hooks.register("attachmentsBrowser/modal", function () {
    var _this = this;

    // Wait the menu, it will immmediatly created
    setTimeout(function () {
      // Check if attachments browser is visible (plugins like ACF do hide it)
      if (!_this.$el.children("ul.attachments").is(":visible")) {
        return;
      }

      var parent = _this.views.parent,
          views = parent.views;
      var frames = views.get(".media-frame-menu");

      if (!frames) {
        // No frames available, for example in the "replace-image" dialog
        parent.views.add(".media-frame-menu", new wp.media.view.Menu({
          controller: _this.controller
        }));
        frames = views.get(".media-frame-menu");
      }

      var _frames = frames,
          _frames2 = _slicedToArray(_frames, 1),
          mediaMenu = _frames2[0],
          mediaMenuViews = mediaMenu.views.get();

      var container = mediaMenuViews && mediaMenuViews.filter(function (v) {
        return v.className === "rml-modal-container";
      });
      container && container.length && (container = container[0]) || (container = undefined);

      if (!container) {
        // Add seperator
        mediaMenu.views.add(new wp.media.View({
          className: "separator"
        })); // Add ReactJS container

        container = new wp.media.View({
          className: "rml-modal-container"
        });
        mediaMenu.views.add(container);
      } // Always enable the menu


      _this.controller.state().set("menu", true, {
        silent: true
      });

      parent.$el.addClass("rml-media-modal").removeClass("hide-menu");
      /**
       * A modal attachments browser is created and the view for the
       * React element is ready.
       *
       * @event module:util/hooks#attachmentsBrowser/modal/dom/ready
       * @param {object} container The backbone view
       * @this wp.media.view.AttachmentsBrowser
       */

      hooks.call("attachmentsBrowser/modal/dom/ready", [container], _this);
      setTimeout(appendMediaModalClass, 0);
    }, 50);
  });
  /**
   * When a tree gets initialized then check if it is a modal and
   * modify the state.
   */

  hooks.register("tree/init", function (state, _ref) {
    var _this2 = this;

    var isModal = _ref.isModal;

    if (isModal && this.attachmentsBrowser) {
      state.isResizable = false, state.isSticky = false;
      state.isStickyHeader = false;
      state.isFullWidth = true; // Update WP attachment sort mode and disable the draggable items

      state.isWPAttachmentsSortMode = isAttachmentsBrowserSortable(this);

      var changeOrderBy = function changeOrderBy() {
        return _this2.setState({
          isWPAttachmentsSortMode: isAttachmentsBrowserSortable(_this2)
        });
      },
          props = this.attachmentsBrowser.collection.props;

      props.on("change:orderby", changeOrderBy);

      this._unsubscribeChangeOrderBy = function () {
        return props.off("change:orderby", changeOrderBy);
      }; // Update previously selected item if tab change is the reason to rerender


      var modal = this.attachmentsBrowser.controller.modal;
      restoreMediaViewSelection(this, modal._rmlFolder, function (_ref2) {
        var id = _ref2.id;
        _this2.attachmentsBrowser.attachments._rmlInitialSetted = true;
        state.initialSelectedId = id;
      });
    }
  });
  /**
   * When a modal tree gets destroyed save the last selected folder in the modal.
   */

  hooks.register("tree/destroy", function (state, _ref3) {
    var isModal = _ref3.isModal,
        store = _ref3.store;

    if (isModal) {
      this.attachmentsBrowser.controller.modal._rmlFolder = store.selectedId;
      var _unsubscribeChangeOrderBy = this._unsubscribeChangeOrderBy;
      _unsubscribeChangeOrderBy && _unsubscribeChangeOrderBy();
      this._unsubscribeChangeOrderBy = undefined;
    }
  });
  /**
   * When the window gets resized check the flexible modal containers
   * for responsiveness.
   */

  $(function () {
    return $(window).resize(function () {
      appendMediaModalClass();
    });
  });
  /* onlypro:end */
}